<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M2 5H3M3 5H16M3 5L3 15.3C3 15.7509 3.17559 16.1833 3.48816 16.5021C3.80072 16.8209 4.22464 17 4.66667 17H13.3333C13.7754 17 14.1993 16.8209 14.5118 16.5021C14.8244 16.1833 15 15.7509 15 15.3V5H3ZM6 5L6 2.7C6 2.24913 6.1756 1.81673 6.48816 1.49792C6.80072 1.17911 7.22464 1 7.66667 1H10.3333C10.7754 1 11.1993 1.17911 11.5118 1.49792C11.8244 1.81673 12 2.24913 12 2.7V5M7 9V13M11 9V13"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'DeleteIcon',
  };
</script>
